// App.jsx
import React, { useEffect, useState, useRef } from "react";
import "materialize-css/dist/css/materialize.min.css";
import M from "materialize-css";
import "./assets/css/styles.css";
import "./assets/css/main.css";
import Contacto from "./components/Contacto";
import Quienes from "./components/Quienes";
import Sumate from "./components/Sumate";
import Informate from "./components/Informate";
import Servicios from "./components/servicios";
import Footer from "./components/footer";
import PayPalDonateButton from "./components/shared/PaypalButton";

import Estafeta from "./components/Estafetas";

export default function FundacionSoffyApp() {
  const [expandedCard, setExpandedCard] = useState(null);
  const carouselFotosRef = useRef(null);
  const carouselVideosRef = useRef(null);
  const [imagenAmpliada, setImagenAmpliada] = useState(null);
  const [videoAmpliado, setVideoAmpliado] = useState(null);
  const [audioPlaying, setAudioPlaying] = useState(false);
  const audioRef = useRef(null);
  const [scrollToForm, setScrollToForm] = useState(false);

  useEffect(() => {
    const modales = document.querySelectorAll(".modal");
    M.Modal.init(modales);
  }, []);

  useEffect(() => {
    if (scrollToForm) {
      const el = document.getElementById("formulario-contacto");
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
      setScrollToForm(false);
    }
  }, [scrollToForm]);

  useEffect(() => {
    const listener = () => handleExpand("contacto", true);
    window.addEventListener("scrollToContacto", listener);
    return () => window.removeEventListener("scrollToContacto", listener);
  }, []);

  useEffect(() => {
    if (expandedCard === null) {
      setTimeout(() => {
        if (carouselFotosRef.current) {
          M.Carousel.init(carouselFotosRef.current, {
            fullWidth: true,
            indicators: true,
          });
        }
        if (carouselVideosRef.current) {
          M.Carousel.init(carouselVideosRef.current, {
            fullWidth: true,
            indicators: true,
          });
        }
      }, 100);
    }
  }, [expandedCard]);

  useEffect(() => {
    if (expandedCard !== null) {
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }, 100);
    }
  }, [expandedCard]);

  useEffect(() => {
    document.body.style.overflow = "auto";
  }, [expandedCard]);

  useEffect(() => {
    const fotos = M.Carousel.init(carouselFotosRef.current, {
      fullWidth: true,
      indicators: true,
    });
    const videos = M.Carousel.init(carouselVideosRef.current, {
      fullWidth: true,
      indicators: true,
    });

    return () => {
      if (fotos) fotos.destroy();
      if (videos) videos.destroy();
    };
  }, []);

  const videoItems = [
    {
      url: "https://www.instagram.com/p/DKftqI2SvRW/embed",
      vertical: true,
      title: "Instagram Video",
    },
    {
      url: "https://www.youtube.com/embed/VrGbZ3o_LT4",
      vertical: false,
      title: "Video presentación maestra",
    },
    {
      url: "https://www.instagram.com/reel/DIkGAGYySZG/embed",
      vertical: true,
      title: "Pao habla de su caso",
    },
    {
      url: "https://www.instagram.com/reel/DJALiGDSJWo/embed",
      vertical: true,
      title: "Eunice habla de su caso",
    },
    {
      url: "https://www.instagram.com/reel/DJpnj0xS6T0/embed",
      vertical: true,
      title: "Lupita habla de su caso",
    },
    {
      url: "https://www.youtube.com/embed/TtlauHStzYE",
      vertical: false,
      title: "CARI (Centro de Atención Renal de Fundación Soffy)",
    },
    {
      url: "https://www.youtube.com/embed/nuQvlF8knH4",
      vertical: false,
      title: "Origen de Fundación Soffy",
    },
    {
      url: "https://www.youtube.com/embed/ADZUnH3UjT8",
      vertical: false,
      title: "Centro ADZUnH3UjT8",
    },
    {
      url: "https://www.instagram.com/reel/DKKqNpqPEm1/embed",
      vertical: true,
      title: "Estafeta contra el cáncer 1",
    },
    {
      url: "https://www.instagram.com/reel/DKKuFnevImg/embed",
      vertical: true,
      title: "Estafeta contra el cáncer 2",
    },
    {
      url: "https://www.instagram.com/reel/DK0YOgssr0F/embed",
      vertical: true,
      title: "Un homenaje a nuestra querida Yuli",
    },
    {
      url: "https://www.instagram.com/reel/DK5Fo6gP3ey/embed",
      vertical: true,
      title: "Gracias Motociclistas de Querétaro por su valioso trabajo y apoyo",
    },
    {
      url: "https://www.instagram.com/reel/DK-73NPsFG-/embed",
      vertical: true,
      title: "Gracias Motociclistas del Estado de México por su valioso trabajo y apoyo",
    },
    {
      url: "https://www.instagram.com/reel/DLa6y69SW74/embed",
      vertical: true,
      title: "Hoy celebramos la vida de Juan Ángel",
    },
    {
      url: "https://www.instagram.com/reel/DLvWT3syM0i/embed",
      vertical: true,
      title: "Las Familiares de Naomi nos cuentan un poco sobre la enfermedad que enfrenta esta pequeña guerrera",
    },
    {
      url: "https://www.instagram.com/reel/DL8GGz7yFgs/embed",
      vertical: true,
      title: "Axel tiene 17 años y está luchando contra la leucemia",
    },
    {
      url: "https://www.instagram.com/reel/DMZFlyyM27y/embed",
      vertical: true,
      title: "Reel DMZFlyyM27y",
    },
    {
      url: "https://www.instagram.com/reel/DNGnnfRsASb/embed",
      vertical: true,
      title: "Reel DNGnnfRsASb",
    },
    {
      url: "https://www.instagram.com/reel/DNRPxLny9Mc/embed",
      vertical: true,
      title: "Reel DNRPxLny9Mc",
    },
    {
      url: "https://www.instagram.com/reel/DNoLgFaPr6s/embed",
      vertical: true,
      title: "Reel DNoLgFaPr6s",
    },
    {
      url: "https://www.instagram.com/reel/DNoN-uZvMjA/embed",
      vertical: true,
      title: "Reel DNoN-uZvMjA",
    },
    {
      url: "https://www.instagram.com/reel/DN1OlPCZD7i/embed",
      vertical: true,
      title: "Reel DN1OlPCZD7i",
    },
    {
      url: "https://www.instagram.com/reel/DOO5dkeEh-9/embed",
      vertical: true,
      title: "Reel DOO5dkeEh-9",
    },
    {
      url: "https://www.instagram.com/reel/DOY1-btDWTj/embed",
      vertical: true,
      title: "Reel DOY1-btDWTj",
    },
  ];

  const goToPrevFotos = () => {
    const instance = M.Carousel.getInstance(carouselFotosRef.current);
    if (instance) instance.prev();
  };

  const goToNextFotos = () => {
    const instance = M.Carousel.getInstance(carouselFotosRef.current);
    if (instance) instance.next();
  };

  const goToPrevVideos = () => {
    const instance = M.Carousel.getInstance(carouselVideosRef.current);
    if (instance) instance.prev();
  };

  const goToNextVideos = () => {
    const instance = M.Carousel.getInstance(carouselVideosRef.current);
    if (instance) instance.next();
  };

  const cardsInfo = [
    {
      id: "quienes",
      title: "¿Quiénes somos?",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="#f299ca"
          viewBox="0 0 24 24"
        >
          <path
            d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 
          5.42 4.42 3 7.5 3c1.74 0 3.41 0.81 4.5 
          2.09C13.09 3.81 14.76 3 16.5 
          3 19.58 3 22 5.42 22 8.5c0 
          3.78-3.4 6.86-8.55 11.54L12 21.35z"
          />
        </svg>
      ),
    },
    {
      id: "sumate",
      title: "Súmate",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          fill="#899bc8"
          viewBox="0 0 24 24"
        >
          <path d="M12 12c2.7 0 4.88-2.18 4.88-4.88S14.7 2.25 12 2.25 7.12 4.43 7.12 7.12 9.3 12 12 12Zm0 1.5c-3.06 0-9 1.53-9 4.59v1.41c0 .41.34.75.75.75h16.5c.41 0 .75-.34.75-.75v-1.41c0-3.06-5.94-4.59-9-4.59Z" />
        </svg>
      ),
    },
    {
      id: "informate",
      title: "Infórmate",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="#f299ca"
          viewBox="0 0 24 24"
        >
          <path d="M12 2a10 10 0 1 0 10 10A10.011 10.011 0 0 0 12 2zm1 15h-2v-2h2zm0-4h-2V7h2z" />
        </svg>
      ),
    },
    {
      id: "contacto",
      title: "Contacto",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          fill="#899bc8"
          viewBox="0 0 24 24"
        >
          <path d="M4 4h16c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H6l-4 4V6c0-1.1.9-2 2-2Zm2 5h12v2H6V9Zm0-3h12v2H6V6Zm0 6h8v2H6v-2Z" />
        </svg>
      ),
    },
  ];

  const handleExpand = (id, scrollForm = false) => {
    setExpandedCard((prev) => {
      const newId = prev === id ? null : id;

      if (newId === "contacto") {
        setTimeout(() => {
          if (scrollForm) {
            // setScrollToForm(true);
          }
        }, 400);
      }

      return newId;
    });
  };

  const handleBack = () => {
    setExpandedCard(null);
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 50);
  };

  const cerrarImagenAmpliada = () => setImagenAmpliada(null);

  const renderExpandedComponent = () => {
    switch (expandedCard) {
      case "quienes":
        return <Quienes onBack={handleBack} />;
      case "sumate":
        return <Sumate onBack={handleBack} />;
      case "informate":
        return <Informate onBack={handleBack} />;
      case "contacto":
        return <Contacto onBack={handleBack} />;
      case "servicios":
        return <Servicios onBack={handleBack} />;
      case "estafeta":
        return <Estafeta onBack={handleBack} />;
      default:
        return null;
    }
  };

  return (
    <>
      {/* HEADER */}
      <header>
        <audio ref={audioRef} src="assets/audio/audio.mpeg" />

        <nav
          className="hide-on-small-only"
          style={{ backgroundColor: "white", height: "80px" }}
        >
          <div className="nav-wrapper container">
            <button
              type="button"
              className="left"
              onClick={() => {
                setExpandedCard(null);
                setTimeout(
                  () => window.scrollTo({ top: 0, behavior: "smooth" }),
                  50
                );
              }}
              style={{
                background: "transparent",
                border: "none",
                padding: 0,
                cursor: "pointer",
              }}
              aria-label="Ir al inicio"
            >
              <img
                src="assets/images/logo_soffy.png"
                alt="Logo"
                style={{ height: "100px", marginTop: "-15px" }}
              />
            </button>

            <ul className="right">
              <ul
                className="right"
                style={{
                  display: "flex",
                  gap: "1rem",
                  alignItems: "center",
                }}
              >
                <li>
                  <button
                    type="button"
                    className="btn"
                    style={{
                      backgroundColor: "#f299ca",
                      borderRadius: "30px",
                      fontWeight: "bold",
                      textShadow: "1px 1px 3px rgba(0,0,0,0.3)",
                    }}
                    onClick={() => handleExpand("servicios")}
                  >
                    Servicios
                  </button>
                </li>

                <li>
                  <button
                    type="button"
                    className="btn"
                    style={{
                      backgroundColor: "#899bc8",
                      borderRadius: "30px",
                      fontWeight: "bold",
                      textShadow: "1px 1px 3px rgba(0,0,0,0.3)",
                    }}
                    onClick={() => handleExpand("quienes")}
                  >
                    ¿Quiénes somos?
                  </button>
                </li>

                <li>
                  <button
                    type="button"
                    className="btn"
                    style={{
                      backgroundColor: "#f299ca",
                      borderRadius: "30px",
                      fontWeight: "bold",
                      textShadow: "1px 1px 3px rgba(0,0,0,0.3)",
                    }}
                    onClick={() => handleExpand("sumate")}
                  >
                    Súmate
                  </button>
                </li>

                <li>
                  <button
                    type="button"
                    className="btn"
                    style={{
                      backgroundColor: "#899bc8",
                      borderRadius: "30px",
                      fontWeight: "bold",
                      textShadow: "1px 1px 3px rgba(0,0,0,0.3)",
                    }}
                    onClick={() => handleExpand("informate")}
                  >
                    Infórmate
                  </button>
                </li>

                <li>
                  <button
                    type="button"
                    className="btn"
                    style={{
                      backgroundColor: "#f299ca",
                      borderRadius: "30px",
                      fontWeight: "bold",
                      textShadow: "1px 1px 3px rgba(0,0,0,0.3)",
                    }}
                    onClick={() => handleExpand("contacto")}
                  >
                    Contacto
                  </button>
                </li>
              </ul>
            </ul>
          </div>
        </nav>

        <nav
          className="hide-on-med-and-up"
          style={{
            backgroundColor: "white",
            height: "80px",
            textAlign: "center",
          }}
        >
          <div className="nav-wrapper" style={{ alignContent: "center" }}>
            <button
              type="button"
              className="center"
              onClick={() => {
                setExpandedCard(null);
                setTimeout(
                  () => window.scrollTo({ top: 0, behavior: "smooth" }),
                  50
                );
              }}
              style={{
                background: "transparent",
                border: "none",
                padding: 0,
                cursor: "pointer",
              }}
              aria-label="Ir al inicio"
            >
              <img
                src="assets/images/logo_soffy.png"
                alt="Logo"
                style={{ height: "100px", marginTop: "-15px" }}
              />
            </button>
          </div>
        </nav>
      </header>

      {imagenAmpliada && (
        <div
          onClick={cerrarImagenAmpliada}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.8)",
            zIndex: 1000,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            src={imagenAmpliada}
            alt="Imagen ampliada"
            onClick={(e) => e.stopPropagation()}
            style={{
              maxWidth: "90vw",
              maxHeight: "80vh",
              borderRadius: "20px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.5)",
            }}
          />
          <button
            onClick={cerrarImagenAmpliada}
            style={{
              position: "absolute",
              top: "2rem",
              right: "2rem",
              background: "white",
              border: "none",
              borderRadius: "50%",
              width: "40px",
              height: "40px",
              fontSize: "24px",
              fontWeight: "bold",
              cursor: "pointer",
              boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
            }}
          >
            ×
          </button>
        </div>
      )}

      {videoAmpliado && (
        <div
          onClick={() => setVideoAmpliado(null)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.8)",
            zIndex: 1000,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              width: videoAmpliado.vertical ? "auto" : "90vw",
              height: videoAmpliado.vertical ? "90vh" : "60vh",
              aspectRatio: videoAmpliado.vertical ? "9 / 16" : "16 / 9",
              position: "relative",
              background: "#000",
              borderRadius: "16px",
              overflow: "hidden",
              boxShadow: "0 4px 12px rgba(0,0,0,0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <iframe
              src={videoAmpliado.url}
              allow="autoplay; clipboard-write; encrypted-media; picture-in-picture"
              allowFullScreen
              title="Video ampliado"
              style={{
                width: "100%",
                height: "100%",
                border: "none",
              }}
            ></iframe>
            <button
              onClick={() => setVideoAmpliado(null)}
              style={{
                position: "absolute",
                top: "1rem",
                right: "1rem",
                background: "white",
                border: "none",
                borderRadius: "50%",
                width: "40px",
                height: "40px",
                fontSize: "24px",
                fontWeight: "bold",
                cursor: "pointer",
              }}
            >
              ×
            </button>
          </div>
        </div>
      )}

      <main>
        {!expandedCard && (
          <>
            {/* CONTENIDO PRINCIPAL ORIGINAL */}
            <div className="row">
              <div
                className="card col l8 offset-l2"
                style={{
                  borderRadius: "20px",
                  backgroundColor: "rgba(255,255,255,0.5)",
                  boxShadow: "none",
                  userSelect: "none",
                }}
              >
                <div className="container center col l7">
                  <p style={{ fontSize: "22px", fontWeight: 700 }}>
                    Somos una asociación civil sin fines de lucro que realiza
                    actividades humanitarias para apoyar a las niñas, niños y
                    adolescentes con cáncer y enfermedades
                    crónico-degenerativas.
                  </p>
                  <br />
                </div>

                <div className="col l5 center">
                  <h5
                    className="center-align"
                    style={{
                      color: "#ef7cab",
                      fontWeight: "600",
                      marginBottom: "1rem",
                    }}
                  >
                    Apóyanos con una donación (PayPal)
                  </h5>

                  <PayPalDonateButton />

                  <h6 style={{ fontWeight: "bolder", fontSize: "14px" }}>
                    En caso de requerir factura por su donativo, envienos su
                    Comprbante del Donativo realizado y su constancia de
                    situación fiscal al correo{" "}
                    <a href="mailto:fundacionsoffy@gmail.com">
                      fundacionsoffy@gmail.com
                    </a>
                  </h6>
                </div>

                <div className="col l12 m12 s12">
                  {/* COLUMNA IZQUIERDA: IMAGEN */}
                  <div className="col s12 m12 l9" >
                    <div className="container center col l12">
                      <br></br>
                    </div>

                    <a
                      href="https://www.facebook.com/events/1542454323594948/?acontext=%7B%22event_action_history%22%3A[%7B%22mechanism%22%3A%22attachment%22%2C%22surface%22%3A%22newsfeed%22%7D]%2C%22ref_notif_type%22%3Anull%7D"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src="assets/images/principal.jpeg"
                        alt="Imagen decorativa"
                        style={{
                          width: "100%",
                          maxWidth: "100%",
                          borderRadius: "24px",
                          objectFit: "cover",
                          position: "relative",
                          boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
                          cursor: "pointer",
                        }}
                      />
                    </a>
                  </div>

                  {/* COLUMNA DERECHA: BANK + HIMNO + CAROUSELES */}
                  <div className="col s12 m12 l3">
                    {/* CARD BANCARIO (aquí, dentro de la columna derecha) */}
                    <div
                      className="card bank-mini-card"
                      style={{
                        borderRadius: "20px",
                        marginBottom: "0.75rem",
                        overflow: "hidden",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.10)",
                      }}
                    >
                      <div
                        style={{
                          padding: "14px 16px",
                          background:
                            "linear-gradient(90deg, rgba(242,153,202,0.25), rgba(137,155,200,0.25))",
                          borderBottom: "1px solid rgba(0,0,0,0.05)",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                          }}
                        >
                          <div
                            style={{
                              width: "36px",
                              height: "36px",
                              borderRadius: "50%",
                              background: "white",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                            }}
                          >
                            <i
                              className="material-icons"
                              style={{ color: "#899bc8" }}
                            >
                              account_balance
                            </i>
                          </div>

                          <div>
                            <div
                              style={{
                                fontWeight: 800,
                                color: "#2e3a59",
                                fontSize: "15px",
                              }}
                            >
                              Donación por transferencia o depósito
                            </div>
                            <div
                              style={{
                                fontSize: "12px",
                                color: "rgba(0,0,0,0.55)",
                              }}
                            >
                              También puedes apoyar realizando una transferencia
                              bancaria
                            </div>
                          </div>
                        </div>
                      </div>

                      <div style={{ padding: "14px 16px", background: "white" }}>
                        <div style={{ marginBottom: "12px" }}>
                          <div className="bank-title">Cuenta </div>

                          <div className="bank-row">
                            <div className="bank-label">
                              Institución bancaria
                            </div>
                            <div className="bank-value">BBVA</div>
                          </div>

                          <div className="bank-row">
                            <div className="bank-label">Cuenta</div>
                            <div className="">
                              0104566785
                            </div>
                          </div>

                          <div className="bank-row" style={{ marginBottom: 0 }}>
                            <div className="bank-label">Cuenta CLABE</div>
                            <div className="">
                              012680001045667857
                            </div>
                          </div>
                        </div>

                        <div className="bank-divider" />

                
                      </div>
                    </div>

                    {/* CARD HIMNO (aquí, dentro de la columna derecha) */}
                    <div
                      className="card himno-card"
                      style={{
                        borderRadius: "20px",
                        marginBottom: "0.75rem",
                        padding: "10px 12px",
                      }}
                    >
                      <div className="row" style={{ marginBottom: 0 }}>
                        <div className="col s9">
                          <h5 style={{ margin: 0 }}>Himno de Fundación Soffy</h5>
                        </div>

                        <div
                          className="col s3"
                          style={{ padding: "5px", textAlign: "right" }}
                        >
                          <button
                            style={{ marginTop: "2px" }}
                            className="btn-floating btn-large pink lighten-1"
                            onClick={() => {
                              const audio = audioRef.current;
                              if (!audio) return;

                              if (audio.paused) {
                                audio.play();
                                setAudioPlaying(true);
                              } else {
                                audio.pause();
                                setAudioPlaying(false);
                              }
                            }}
                          >
                            <i className="material-icons white-text">
                              {audioPlaying ? "pause" : "play_arrow"}
                            </i>
                          </button>
                        </div>
                      </div>
                    </div>

                    {/* Carrusel de Fotos */}
                    <div className="row" style={{ position: "relative" }}>
                      <button
                        className="btn-floating btn pink lighten-1"
                        style={{
                          position: "absolute",
                          top: "70%",
                          left: "10px",
                          zIndex: 10,
                          transform: "translateY(-50%)",
                        }}
                        onClick={goToPrevFotos}
                      >
                        <i className="material-icons">chevron_left</i>
                      </button>

                      <div
                        className="carousel carousel-slider center"
                        ref={carouselFotosRef}
                        style={{
                          height: "25vw",
                          maxHeight: "180px",
                          borderRadius: "16px",
                          
                        }}
                      >
                        {[
                          "carrete1.jpg",
                          "carrete2.jpg",
                          "carrete3.jpeg",
                          "carrete4.jpeg",
                          "carrete5.jpeg",
                          "carrete6.jpeg",
                        ].map((img, idx) => (
                          <div key={idx} className="carousel-item">
                            <img
                              src={`assets/images/carrete/${img}`}
                              alt={`Foto ${idx + 1}`}
                              style={{
                                width: "100%",
                                height: "50%",
                                objectFit: "cover",
                                borderRadius: "16px",
                                cursor: "pointer",
                              }}
                              onClick={() => handleExpand("informate")}
                            />
                          </div>
                        ))}
                      </div>

                      <button
                        className="btn-floating btn pink lighten-1"
                        style={{
                          position: "absolute",
                          top: "70%",
                          right: "10px",
                          zIndex: 10,
                          transform: "translateY(-50%)",
                        }}
                        onClick={goToNextFotos}
                      >
                        <i className="material-icons">chevron_right</i>
                      </button>
                    </div>

                    {/* Carrusel de Video */}
                    <div className="row" style={{ position: "relative" }}>
                      <button
                        className="btn-floating btn pink lighten-1"
                        style={{
                          position: "absolute",
                          top: "50%",
                          left: "10px",
                          zIndex: 10,
                          transform: "translateY(-50%)",
                        }}
                        onClick={goToPrevVideos}
                      >
                        <i className="material-icons">chevron_left</i>
                      </button>

                      <div
                        className="carousel carousel-slider center"
                        ref={carouselVideosRef}
                        style={{
                          height: "25vw",
                          maxHeight: "180px",
                          borderRadius: "16px",
                          overflow: "hidden",
                          backgroundColor: "#000",
                        }}
                      >
                        {videoItems.map((video, idx) => (
                          <div
                            key={idx}
                            className="carousel-item"
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <div
                              style={{
                                width: "100%",
                                height: "100%",
                                cursor: "pointer",
                              }}
                              onClick={() =>
                                setVideoAmpliado({
                                  url: video.url,
                                  vertical: video.vertical,
                                })
                              }
                            >
                              <iframe
                                src={video.url}
                                title={video.title}
                                allow="autoplay; clipboard-write; encrypted-media; picture-in-picture"
                                allowFullScreen
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  border: "none",
                                  pointerEvents: "none",
                                }}
                              ></iframe>
                            </div>
                          </div>
                        ))}
                      </div>

                      <button
                        className="btn-floating btn pink lighten-1"
                        style={{
                          position: "absolute",
                          top: "50%",
                          right: "10px",
                          zIndex: 10,
                          transform: "translateY(-50%)",
                        }}
                        onClick={goToNextVideos}
                      >
                        <i className="material-icons">chevron_right</i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col l12 m12 s12">
                <br />
                <br />
                <br />
              </div>
            </div>

            {/* BOTONES PERSONALIZADOS */}
            <div className="row">
              {/* Botón de SERVICIOS solo en móvil */}
              <div
                className="col s12 hide-on-med-and-up"
                style={{ marginBottom: "1rem" }}
              >
                <div
                  className="card"
                  onClick={() => setExpandedCard("servicios")}
                  style={{
                    borderRadius: "40px",
                    backgroundColor: "#f299ca",
                    display: "flex",
                    alignItems: "center",
                    padding: "10px",
                    cursor: "pointer",
                  }}
                >
                  <div
                    style={{
                      width: "48px",
                      height: "48px",
                      background: "white",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginRight: "10px",
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      fill="#f299ca"
                      viewBox="0 0 24 24"
                    >
                      <path d="M20 6h-2.81A5.978 5.978 0 0 0 12 2a5.978 5.978 0 0 0-5.19 3.01H4a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zM12 4a4 4 0 0 1 3.86 3.01H8.14A4 4 0 0 1 12 4zm8 14H4V8h16v10z" />
                    </svg>
                  </div>
                  <div className="card-content" style={{ padding: 5 }}>
                    <h5
                      className="white-text"
                      style={{ textShadow: "2px 2px 5px rgb(0 0 0 / 60%)" }}
                    >
                      Servicios
                    </h5>
                  </div>
                </div>
              </div>

              {cardsInfo.map((card, idx) => (
                <div
                  key={card.id}
                  className={`col s12 m3 l2 ${
                    idx === 0 ? "offset-l2" : ""
                  }`}
                  onClick={() => setExpandedCard(card.id)}
                  style={{ cursor: "pointer", marginBottom: "1rem" }}
                >
                  <div
                    className="card"
                    style={{
                      borderRadius: "40px",
                      backgroundColor: idx % 2 === 0 ? "#f299ca" : "#899bc8",
                      display: "flex",
                      alignItems: "center",
                      padding: "10px",
                    }}
                  >
                    <div
                      style={{
                        width: "48px",
                        height: "48px",
                        background: "white",
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginRight: "10px",
                      }}
                    >
                      {card.icon}
                    </div>
                    <div className="card-content" style={{ padding: 5 }}>
                      <h5
                        className="white-text"
                        style={{
                          textShadow: "2px 2px 5px rgb(0 0 0 / 60%)",
                        }}
                      >
                        {card.title}
                      </h5>
                    </div>
                  </div>
                </div>
              ))}

              <div
                className="row col s12 m12 l12"
                style={{ alignItems: "center" }}
              >
                {/* Banner Izquierdo */}
                <div
                  className="col s12 m12 l6 offset-l3"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginBottom: "1rem",
                  }}
                >
                  <img
                    src="assets/images/banner/bannerIz.jpg"
                    alt="Banner izquierdo"
                    style={{
                      width: "90%",
                      maxWidth: "40%",
                      borderRadius: "24px",
                      objectFit: "cover",
                      boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
                    }}
                  />
                </div>
              </div>
            </div>
          </>
        )}

        <div className="row">{expandedCard && renderExpandedComponent()}</div>
      </main>

      {/* FOOTER */}
      <Footer />
    </>
  );
}
